var map = {
	"./legend_xg_dark_vertical.png": 84723,
	"./legend_xg_english_dark_vertical.png": 36038,
	"./legend_xg_english_vertical.png": 61549,
	"./legend_xg_spanish_dark_vertical.png": 14054,
	"./legend_xg_spanish_vertical.png": 39949,
	"./legend_xg_vertical.png": 64750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70237;